import { isProduction } from '@application/env';
import { getApps, initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBKc47nV-gHrVcIfWnLb46agEDP7MAmxZE',
  authDomain: 'tipaw-pro.firebaseapp.com',
  databaseURL: 'https://tipaw-pro.firebaseio.com',
  projectId: 'tipaw-pro',
  storageBucket: 'tipaw-pro.appspot.com',
  messagingSenderId: '101933540917',
  appId: '1:101933540917:web:a17f63c0b46d8309',
};

const firebaseDevConfig = {
  apiKey: 'AIzaSyDIJRoKthv1-WU045PZlY2j1IQ_EXBtj6g',
  authDomain: 'tipaw-155911.firebaseapp.com',
  projectId: 'tipaw-155911',
  storageBucket: 'tipaw-155911.appspot.com',
  messagingSenderId: '79854645391',
  appId: '1:79854645391:web:d1c07b1eaa5d2cb450c0fa',
  databaseURL: 'https://tipaw-pro.firebaseio.com/',
};

export const initializeFirebase = () => {
  if (!getApps().length) {
    initializeApp(isProduction() ? firebaseConfig : firebaseDevConfig);
  }
};
